import { isFunction as i } from "../../../../../../utils/value/is.js";
const a = (t, n) => i(t.endpoints[n]), e = {
  transactions: (t) => a(t, "getTransactions"),
  transactionDetails: (t) => a(t, "getTransaction"),
  payouts: (t) => a(t, "getPayouts"),
  payoutDetails: (t) => a(t, "getPayout"),
  reports: (t) => a(t, "getReports"),
  capitalOverview: (t) => a(t, "getDynamicGrantOffersConfiguration"),
  capitalOffer: (t) => a(t, "getDynamicGrantOffer")
};
export {
  e as default
};
